import { Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeProvider";
import { Button } from "./ui/button";

const ThemeToggle = ({ className = "" }) => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      className={`relative w-9 h-9 rounded-xl transition-all duration-300 ${
        theme === "dark" 
          ? "bg-slate-800 hover:bg-slate-700 text-yellow-400" 
          : "hover:bg-slate-100 text-slate-600 hover:text-amber-500"
      } ${className}`}
      title={theme === "dark" ? "Attiva modalità chiara" : "Attiva modalità scura"}
      data-testid="theme-toggle"
    >
      <div className="relative w-5 h-5">
        {/* Sun icon */}
        <Sun 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === "dark" 
              ? "opacity-0 rotate-90 scale-0" 
              : "opacity-100 rotate-0 scale-100"
          }`} 
        />
        {/* Moon icon */}
        <Moon 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 ${
            theme === "dark" 
              ? "opacity-100 rotate-0 scale-100" 
              : "opacity-0 -rotate-90 scale-0"
          }`} 
        />
      </div>
    </Button>
  );
};

export default ThemeToggle;
